import { createSlice } from '@reduxjs/toolkit';

const initialMyOrganisationsState = {
  listLoading: false,
  listAllLoading: false,
  orgSaving: false,
  totalCount: 0,
  entities: null, //with filter
  allEntities: [],
  lastCreatedOrgId: null,
  lastError: null,
  modalData: null,
  error: null,
};

export const callTypes = {
  list: 'list',
  listAll: 'listAll',
  action: 'action',
  saveOrg: 'saveOrg',
};

export const myOrganisationsSlice = createSlice({
  name: 'myOrganisations',
  initialState: initialMyOrganisationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        return;
      }

      if (action.payload.callType === callTypes.listAll) {
        state.listAllLoading = false;
        return;
      }

      if (action.payload.callType === callTypes.saveOrg) {
        state.orgSaving = false;
        return;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
        return;
      }

      if (action.payload.callType === callTypes.listAll) {
        state.listAllLoading = true;
        return;
      }

      if (action.payload.callType === callTypes.saveOrg) {
        state.orgSaving = true;
        state.modalData = null;
        return;
      }
    },

    allMyOrganisationsFetched: (state, action) => {
      const { entities } = action.payload;
      state.listAllLoading = false;
      state.error = null;
      state.allEntities = entities;
    },

    myOrganisationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    saveMyOrganisationsFetched: (state, action) => {
      const { title, type, text, id } = action.payload;
      state.orgSaving = false;
      state.error = null;
      state.lastCreatedOrgId = id;
      state.modalData = {
        text: text,
        title: title,
        type: type,
      };
    },

    clearSaveResponse: state => {
      state.modalData = null;
    },

    clearLastCreatedOrgId: state => {
      state.lastCreatedOrgId = initialMyOrganisationsState.lastCreatedOrgId;
    },
  },
});
